import { render, staticRenderFns } from "./LegalPerson.vue?vue&type=template&id=cbcfc430&"
import script from "./LegalPerson.vue?vue&type=script&lang=js&"
export * from "./LegalPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports